import { useForm, Head, Link } from '@inertiajs/react'
import { useTranslation } from 'react-i18next'
import LanguageSwitcher from '@components/layout/LanguageSwitcher'

interface HomeProps {
  user: {
    email: string
  }
}

export default function Home({ user }: HomeProps) {
  const { delete: destroy } = useForm()
  const { t } = useTranslation()

  const handleSignOut = () => {
    destroy('/session')
  }

  return (
    <>
      <Head title={t('titles.home')} />
      <div className="min-h-screen bg-base-200">
      {/* Navbar */}
      <div className="navbar bg-base-100 shadow-lg">
        <div className="flex-1">
          <a className="btn btn-ghost text-xl">{t('common.fileExplorer')}</a>
        </div>
        <div className="flex-none gap-2">
          <LanguageSwitcher />
          <div className="dropdown dropdown-end">
            <div tabIndex={0} role="button" className="btn btn-ghost btn-circle avatar">
              <div className="w-10 rounded-full bg-primary text-primary-content flex items-center justify-center">
                <span className="text-lg font-bold">
                  {user.email.charAt(0).toUpperCase()}
                </span>
              </div>
            </div>
            <ul
              tabIndex={0}
              className="menu menu-sm dropdown-content bg-base-100 rounded-box z-[1] mt-3 w-52 p-2 shadow"
            >
              <li className="menu-title">
                <span>{user.email}</span>
              </li>
              <li>
                <a onClick={handleSignOut}>{t('auth.signOut')}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto p-8">
        <div className="hero bg-base-100 rounded-box shadow-xl">
          <div className="hero-content text-center py-16">
            <div className="max-w-md">
              <h1 className="text-5xl font-bold">{t('home.welcomeBack')}</h1>
              <p className="py-6 text-lg">
                {t('home.signedInAs')} <span className="font-semibold">{user.email}</span>
              </p>
              <p className="text-base-content/70">
                {t('home.description')}
              </p>
              <div className="mt-8">
                <Link href="/documents" className="btn btn-primary btn-lg">
                  {t('common.viewDocuments')}
                </Link>
              </div>
              <div className="mt-8">
                <div className="stats shadow">
                  <div className="stat">
                    <div className="stat-title">{t('home.totalFiles')}</div>
                    <div className="stat-value">0</div>
                    <div className="stat-desc">{t('home.comingSoon')}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  )
}
